module.exports = __webpack_public_path__ + "static/multiple-editors.3cc379d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/realfire/features/multiple-apex-editors/multiple-editors.png
// module id = 218
// module chunks = 62430881213916 95704636617618